import React, { useState, useEffect } from 'react';
import * as pdfjsLib from 'pdfjs-dist';

// PDF.js worker 설정
if (typeof window !== 'undefined') {
  pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
}

function SimplePDFViewer({ pdfPath }) {
  const [imageData, setImageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPDF = async () => {
      try {
        setLoading(true);
        setError(null);

        // PDF 파일 로드
        const response = await fetch(pdfPath);
        if (!response.ok) {
          throw new Error(`PDF 파일을 불러올 수 없습니다: ${response.status}`);
        }
        
        const arrayBuffer = await response.arrayBuffer();

        const pdf = await pdfjsLib.getDocument({ 
          data: arrayBuffer,
          useWorkerFetch: false,
          isEvalSupported: false,
          useSystemFonts: true
        }).promise;

        // 첫 페이지만 렌더링
        const page = await pdf.getPage(1);
        const viewport = page.getViewport({ scale: 2.0 });

        // Canvas 생성
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        // PDF 페이지 렌더링 (블러 없이)
        await page.render({
          canvasContext: context,
          viewport: viewport,
        }).promise;

        // 이미지로 변환
        const imageDataUrl = canvas.toDataURL('image/png');
        setImageData(imageDataUrl);
        setLoading(false);
      } catch (err) {
        console.error('PDF 로드 오류:', err);
        setError(err.message || 'PDF를 불러올 수 없습니다.');
        setLoading(false);
      }
    };

    if (pdfPath) {
      loadPDF();
    }
  }, [pdfPath]);

  if (loading) {
    return (
      <div className="pdf-loading-container">
        <div className="pdf-loading">
          <div>PDF 로딩 중...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pdf-error-container">
        <div className="pdf-error">{error}</div>
      </div>
    );
  }

  return (
    <img
      src={imageData}
      alt="수료증"
      className="achievement-image"
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
}

export default SimplePDFViewer;

